export default "__VITE_ASSET__d5731bd7__"